import {
  ABROAD_BIRTH_PLACE_ID,
  FOR_ME_IS_TRUE,
  ISSUE_COPY_NAUTICAL,
} from "../../../../constants";
import ls from "local-storage";

import _ from "lodash";

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

//Check if the application is Copy of Nautical and return true or false to hide the extra fields
const checkCopyNauticalApplication = (id) => {
  if (parseInt(id) === parseInt(ISSUE_COPY_NAUTICAL)) {
    return true;
  } else {
    return false;
  }
};

const onSubmit = async (
  values,
  { setSubmitting },
  forMe,
  setErrorFormik,
  mutate,
  nauticalPdColor,
  id
) => {
  setErrorFormik("");
  let documents = [];
  let topos_eggrafis = "";

  for (let i = 0; i < values?.documents?.length; i++) {
    let filesBase64 = [];

    const filesArray = _.get(values, `documents[${i}].files`, []);

    if (values?.documents?.[i]) {
      for (let j = 0; j < filesArray.length; j++) {
        filesBase64.push({
          filename: filesArray?.[j]?.name,
          data: await toBase64(filesArray?.[j]),
          contentType: filesArray?.[j]?.type,
        });
      }
    }

    if (values.documents?.[i]) {
      documents.push({ ...values.documents?.[i], files: filesBase64 });
    }
  }

  values.place_birth_afora?.id !== ABROAD_BIRTH_PLACE_ID // Check if birth place !== ABROAD_BIRTH_PLACE_ID and put topos_eggrafis =null otherwise puts the value added by the user
    ? (topos_eggrafis = "")
    : (topos_eggrafis = values.topos_eggrafis_dimotologiou_ellada);

  if (forMe === FOR_ME_IS_TRUE) {
    mutate({
      // application
      port_authority_id: values.portAuthority?.id,
      appl_kind_id: values.appl_kind_id,
      appl_dt: values.appl_dt,
      reg_num: values.reg_num,

      // applicant
      lname_ait: values.lname_afora,
      fname_ait: values.fname_afora,
      afm_ait: values.afm_afora,
      amka_ait: values.amka_afora,
      meth_ait: values.meth_afora,
      ind_nr_ait: values.ind_nr_afora,
      fath_lname_ait: values.fath_lname_afora,
      fath_fname_ait: values.fath_fname_afora,
      address_ait: values.address_afora,
      address_nr_ait: values.address_nr_afora,
      tk_ait: values.tk_afora,
      tel_ait: values.tel_afora,
      mobile_ait: values.mobile_afora,
      email_ait: values.email_afora,

      // person concerned with the application
      lname_afora: values.lname_afora,
      fname_afora: values.fname_afora,
      afm_afora: values.afm_afora,
      amka_afora: values.amka_afora,
      meth_afora: values.meth_afora,
      ind_nr_afora: values.ind_nr_afora,
      fath_lname_afora: values.fath_lname_afora,
      fath_fname_afora: values.fath_fname_afora,
      moth_lname_afora: values.moth_lname_afora,
      moth_fname_afora: values.moth_fname_afora,
      dt_birth_afora: values.dt_birth_afora || null,
      place_birth_afora: values.place_birth_afora?.id || null,
      dimos_diamonis_afora: values.dimos_diamonis_afora?.id || null,
      address_afora: values.address_afora,
      address_nr_afora: values.address_nr_afora,
      tk_afora: values.tk_afora,
      tel_afora: values.tel_afora,
      mobile_afora: values.mobile_afora,
      email_afora: values.email_afora,
      status: values.status,
      pickup_place_id: values.pickup_place?.id,
      sintaksiouxos_afora: !isNaN(parseInt(values.sintaksiouxos_afora))
        ? parseInt(values.sintaksiouxos_afora)
        : null,
      epipedo_ekpaideusis_afora: values.epipedo_ekpaideusis_afora?.id || null,
      topos_eggrafis_dimotologiou_ellada: topos_eggrafis,
      documents: JSON.stringify(documents),
      nauticalPdColor,
      gender_afora: values.gender_afora?.id || null,
      nationality_afora: values.nationality_afora,
      read_dilosi_idiotiton: values.read_dilosi_idiotiton === true ? 1 : null,
      reason_for_copy_nautical_issue: values.reason_for_copy_nautical_issue
        ? parseInt(values.reason_for_copy_nautical_issue)
        : null,
      didactic_year_id:
        values.didacticYear && values.didacticYear?.id !== -10
          ? values.didacticYear?.id
          : null,
      birth_country_id: values?.birth_country?.id,
      birth_city_not_greece: values?.birth_city_not_greece || null,
    });
  } else {
    mutate({
      // application
      port_authority_id: values.portAuthority?.id,
      appl_kind_id: values.appl_kind_id,
      appl_dt: values.appl_dt,
      reg_num: values.reg_num,

      // applicant
      lname_ait: values.lname_ait,
      fname_ait: values.fname_ait,
      afm_ait: values.afm_ait,
      amka_ait: values.amka_ait,
      meth_ait: values.meth_ait,
      ind_nr_ait: values.ind_nr_ait,
      fath_lname_ait: values.fath_lname_ait,
      fath_fname_ait: values.fath_fname_ait,
      address_ait: values.address_ait,
      address_nr_ait: values.address_nr_ait,
      tk_ait: values.tk_ait,
      tel_ait: values.tel_ait,
      mobile_ait: values.mobile_ait,
      email_ait: values.email_ait,

      // person concerned with the application
      lname_afora: values.lname_afora,
      fname_afora: values.fname_afora,
      afm_afora: values.afm_afora,
      amka_afora: values.amka_afora,
      meth_afora: values.meth_afora,
      ind_nr_afora: values.ind_nr_afora,
      fath_lname_afora: values.fath_lname_afora,
      fath_fname_afora: values.fath_fname_afora,
      moth_lname_afora: values.moth_lname_afora,
      moth_fname_afora: values.moth_fname_afora,
      dt_birth_afora: values.dt_birth_afora || null,
      place_birth_afora: values.place_birth_afora?.id || null,
      dimos_diamonis_afora: values.dimos_diamonis_afora?.id || null,
      address_afora: values.address_afora,
      address_nr_afora: values.address_nr_afora,
      tk_afora: values.tk_afora,
      tel_afora: values.tel_afora,
      mobile_afora: values.mobile_afora,
      email_afora: values.email_afora,
      status: values.status,
      pickup_place_id: values.pickup_place?.id,
      documents: JSON.stringify(documents),
      sintaksiouxos_afora: !isNaN(parseInt(values.sintaksiouxos_afora))
        ? parseInt(values.sintaksiouxos_afora)
        : null,
      epipedo_ekpaideusis_afora: values.epipedo_ekpaideusis_afora?.id || null,
      topos_eggrafis_dimotologiou_ellada: topos_eggrafis,
      nauticalPdColor,
      gender_afora: values.gender_afora?.id || null,
      nationality_afora: values.nationality_afora,
      read_dilosi_idiotiton: values.read_dilosi_idiotiton === true ? 1 : null,
      reason_for_copy_nautical_issue: values.reason_for_copy_nautical_issue
        ? parseInt(values.reason_for_copy_nautical_issue)
        : null,
      didactic_year_id:
        values.didacticYear && values.didacticYear?.id !== -10
          ? values.didacticYear?.id
          : null,
      birth_country_id: values?.birth_country?.id,
      birth_city_not_greece: values?.birth_city_not_greece || null,
      criminal_record_requestId:
        values?.place_birth_afora?.criminal_record_requestId,
    });
  }
  setSubmitting(false);
};

export default onSubmit;
